/** The subset of a person every vehicle surface has on hand. */
export interface OwnerPhotoSource {
  profile_picture_url?: string | null;
  identity_photo?: { photo_url?: string | null } | null;
  identity_photo_url?: string | null;
}

/**
 * The photo that stands for a vehicle's owner: their verified identity photo, and only then
 * their profile picture.
 *
 * The vehicle cards and the detail modal both had this the other way round
 * (`profile_picture_url || identity_photo?.photo_url`), so the profile picture won whenever
 * one existed. A profile picture is whatever the account holder uploaded — it is not
 * necessarily a face, and on mobile it has been seen falling back to the condo's logo — while
 * the identity photo is the face the condo verified and the readers enrol. For "who owns this
 * car", the verified face is the answer.
 *
 * Endpoints differ on shape: some embed the record, some flatten it to identity_photo_url.
 * Both are accepted so call sites do not each re-derive it.
 */
export function ownerAvatarUrl(person: OwnerPhotoSource | null | undefined): string | null {
  if (!person) return null;
  // Empty strings are not photos; letting one through would beat a usable profile picture.
  return (
    person.identity_photo?.photo_url ||
    person.identity_photo_url ||
    person.profile_picture_url ||
    null
  );
}
